module.exports = __webpack_public_path__ + "static/media/coverSmallImages.c9c29c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/coverSmallImages.png
// module id = 991
// module chunks = 0